import { TextReveal } from "./TextReveal";

export function SectionHeader({ number, title, height = "4px" }) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
      <div className="flex items-center gap-4 md:gap-6">
        <TextReveal>
          <div className="flex items-center gap-3 md:gap-4">
            {number && (
              <span className="text-[40px] md:text-[60px] leading-[60px] text-[#fd5b38]">
                {number}
              </span>
            )}
            <div
              className={`h-${
                height === "1px" ? "px" : "[" + height + "]"
              } w-8 md:w-12 bg-[#fd5b38]`}
            />
            {/* <div
              className={`h-[4px] w-8 md:w-12 bg-[#fd5b38]`}
            /> */}
          </div>
        </TextReveal>
      </div>
      <TextReveal delay={0.1}>
        <h2 className="text-4xl md:text-5xl font-normal text-white">
          {title}
        </h2>
      </TextReveal>
    </div>
  );
}
